'use client';

import axios, { endpoints } from 'src/utils/axios';

import { setAllSession } from './utils';

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ username, password }) => {
  try {
    const params = { username, password };

    const res = await axios.post(endpoints.auth.signIn, params);

    console.log(res);
    console.log(res.data);

    const { token, branchs, accessLevel, accessMenu, accessMenus, accesssubMenus } = res.data;

    if (!token) {
      throw new Error('Access token not found in response');
    }
    setAllSession(token, accessLevel, branchs, accessMenu, accessMenus, accesssubMenus);
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async (formData) => {
  try {
    const res = await axios.post(endpoints.auth.signUp, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // const { accessToken } = res.data;

    // if (!accessToken) {
    //   throw new Error('Access token not found in response');
    // }

    // localStorage.setItem(STORAGE_KEY, accessToken);
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  try {
    await setAllSession(null, null, null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
